import { createMatchSelector, push } from 'connected-react-router';
import { computeCheckoutQuantityAndTotal } from 'containers/CheckoutStep1Page/saga';
import { getDeliveryFee, cart as cartActions } from 'containers/MainLayout/actions';
import moment from 'moment';
import { call, fork, put, select, take } from 'redux-saga/effects';
import { getOrderDraft } from 'utils/apollo';
import { getOrderDraft as getOrderDraftActions } from './actions';
import ActionTypes from './constants';
import selectCheckoutStep3Page from './selectors';
import { selectCart } from '../MainLayout/selectors';
import { isEqualCartItems } from 'containers/CheckoutPage/saga';
import { setSomethingChanged } from 'containers/CheckoutPage/actions';

function computeCheckoutDeliveryDate(orderDrafts: any) {
  return orderDrafts.reduce((agg, singleSupplierCart) => {
    const selectedDeliveryStart = moment(singleSupplierCart.deliveryDatetime.start);
    agg[singleSupplierCart.supplier.id] = selectedDeliveryStart.format('DD/MM/YYYY');
    return agg;
  }, {});
}

function computeCheckout(cart: any) {
  return {
    deliveryDate: computeCheckoutDeliveryDate(cart.orderDrafts),
    ...computeCheckoutQuantityAndTotal(cart.orderDrafts),
  };
}

function* initCheckoutStep3Flow() {
  const route = yield select(createMatchSelector('/checkout/step/confirm/:slug'));
  yield put(getOrderDraftActions.request());

  const response = yield call(getOrderDraft, {
    token: route.params.slug,
  });
  const cart = yield select(selectCart());

  const cartDraft = response.orderDrafts.reduce((acc, item) => {
    acc[item.supplier.id] = {
      items: item.items.map((it) => ({
        product: it.product,
        quantity: it.quantity,
      })),
      totalVat: item.totalVat,
      totalVatOnProducts: item.totalVatOnProducts,
      subTotalBeforeVat: item.subTotalBeforeVat,
      invoiceNote: item.invoiceNote,
    };
    return acc;
  }, {});
  const newCartSet = cart.cartSet.map((cart) => ({
    ...cart,
    items: cartDraft?.[cart?.supplier?.id]?.items || cart.items,
    totalVat: cartDraft?.[cart?.supplier?.id]?.totalVat,
    totalVatOnProducts: cartDraft?.[cart?.supplier?.id]?.totalVatOnProducts,
    subTotalBeforeVat: cartDraft?.[cart?.supplier?.id]?.subTotalBeforeVat,
    invoiceNote: cartDraft?.[cart?.supplier?.id]?.invoiceNote,
  }));

  if (!response || response.errors) {
    yield put(getOrderDraftActions.failure(response.errors));
    yield put(push('/checkout/step/2'));
  } else {
    if (!isEqualCartItems(cart?.cartSet[0].items, newCartSet[0].items)) {
      yield put(setSomethingChanged());
      return;
    }
    yield put(
      cartActions.success({
        ...cart,
        cartSet: newCartSet,
      }),
    );
    yield put(
      getOrderDraftActions.success({
        orderDrafts: response.orderDrafts,
        checkout: computeCheckout(response),
        store: response.store,
      }),
    );
  }
}

function* getDeliveryFeeFlow() {
  while (true) {
    yield take(ActionTypes.GET_ORDER_DRAFT_SUCCESS);
    const checkoutStep3Data = yield select(selectCheckoutStep3Page());
    yield put(getDeliveryFee.request({ totalPrice: checkoutStep3Data?.checkout?.total }));
  }
}

export default function* checkoutStep3PageSaga() {
  yield fork(initCheckoutStep3Flow);
  yield fork(getDeliveryFeeFlow);
}
